import React from 'react'
import { useState } from 'react'
import { NavLink,useLocation} from 'react-router-dom'
import '../Css/Navbar.css'
import logo2 from '../Logo/logo2.png';


function Navbar() {
    
    //Toggle Menu
    //save the state of toggle Menu
    const [isOpen,setIsOpen] =useState(false);
    
    //location
    const location = useLocation();
    
    //ToggleMenu Function
    const toggleMenu=()=>{
        setIsOpen(!isOpen);
    };

    const isHome = location.pathname==='/home';
    const isEvent = location.pathname==='/event';
    const isBooking = location.pathname ==='/booking';
    const isPhotoGallery = location.pathname==='/photoGallery';
    const isLive = location.pathname==='/youtubelive';
    const isRegistry = location.pathname==='/registry';
    const isMyBooking = location.pathname==='/myBooking';
    const isSponsor = location.pathname==='/sponsor';

    return (
    <nav className="navbar">
        <div className ="navbar-container">
            {/*Logo on the left*/}
            <div className="navbar-logo">
                <img src ={logo2}
                    alt="Poker Tournament Association"
                    width={93}
                    height={41}
                    className="responsive-image"
                />
                <div className="companyName">
                    POKER TOURNAMENT 
                    <span id="lastCompanyName">
                        ASSOCIATION
                    </span>
                </div>
            </div>

            {/*Hamburger menu icon for mobile */}
            <div className="navbar-toggle" onClick ={toggleMenu}>
                <span className={`bar ${isOpen ?'open':''}`}></span>
                <span className={`bar ${isOpen ?'open':''}`}></span>
                <span className={`bar ${isOpen ?'open':''}`}></span>
            </div>

            {/* Navigation item on the right*/}
            <div className={`navbar-links ${isOpen ? 'active':''}`}>
                <ul>
                    <li>
                        <NavLink
                            to="/home"
                            activeClassName="active-link"
                            onClick={()=>setIsOpen(false)}
                            className={isHome ? 'link-acive':''}
                        >
                            主頁
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/event"
                            activeClassName="active-link"
                            onClick={()=>setIsOpen(false)}
                            className={isEvent ? 'link-active':''}
                        >
                            比賽列表    
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/booking"
                            activeClassName="active-link"
                            onClick={()=>setIsOpen(false)}
                            className={isBooking? 'link-active':''}
                        >
                            預約比賽    
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/myBooking"
                            activeClassName="active-link"
                            onClick={()=>setIsOpen(false)}
                            className={isMyBooking? 'link-active':''}
                        >
                            我的預約    
                        </NavLink>
                    </li>

                    <li>
                        <NavLink
                            to="/photoGallery"
                            activeClassName="active-link"
                            onClick={()=>setIsOpen(false)}
                            className={isPhotoGallery ? "link-active":''}
                        >
                            比賽實況      
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/youtubelive"
                            activeClassName="active-link"
                            onClick={()=>setIsOpen(false)}
                            className={isLive ? "link-active":''}
                        >
                            直播
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/registry"
                            activeClassName="active-link"
                            onClick={()=>setIsOpen(false)}
                            className={isRegistry ?"link-active":''}
                        >
                            註冊
                        </NavLink>
                    </li>
                     <li>
                        <NavLink
                            to="/sponsor"
                            activeClassName="active-link"
                            onClick={()=>setIsOpen(false)}
                            className={isSponsor ?"link-active":''}
                        >
                            贊助我們
                        </NavLink>
                    </li>
                </ul>

            </div>    


        </div>
    
    
    </nav>    
  )
}

export default Navbar
